import React from "react";

const FONT = "Inter, ui-sans-serif, system-ui, sans-serif";
const DISPLAY = "'Space Grotesk', Inter, sans-serif";

/* Connected vehicle: a van with live sensor callouts streaming telemetry */
export const ConnectedVehicleVisual = ({ className = "" }) => {
  const callouts = [
    { x: 22, y: 36, w: 150, label: "GPS · 25.0987, 55.1773", value: "64 km/h · NE", color: "#4C30FF", to: [250, 150] },
    { x: 308, y: 36, w: 150, label: "ENGINE · CAN-BUS", value: "1,840 rpm · 92°C", color: "#0E0E10", to: [300, 160] },
    { x: 22, y: 300, w: 150, label: "FUEL LEVEL", value: "62% · -0.8 L/h idle", color: "#16A34A", to: [185, 236] },
    { x: 308, y: 300, w: 150, label: "TEMP SENSOR · CARGO", value: "4.2°C · door closed", color: "#4C30FF", to: [226, 210] },
  ];
  return (
    <svg viewBox="0 0 480 400" xmlns="http://www.w3.org/2000/svg" className={className} role="img" aria-label="Connected vehicle streaming GPS, engine, fuel and temperature data" data-testid="connected-vehicle-visual">
      <defs>
        <pattern id="cv-grid" width="24" height="24" patternUnits="userSpaceOnUse">
          <path d="M24 0H0V24" fill="none" stroke="#EEEEE9" strokeWidth="1" />
        </pattern>
        <filter id="cv-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#0E0E10" floodOpacity="0.10" />
        </filter>
      </defs>
      <rect width="480" height="400" fill="#FFFFFF" />
      <rect width="480" height="400" fill="url(#cv-grid)" />

      {/* radar rings */}
      {[70, 110, 150].map((r, i) => (
        <circle key={r} cx="250" cy="200" r={r} fill="none" stroke="#4C30FF" strokeOpacity="0.12" strokeDasharray="4 6">
          <animate attributeName="r" values={`${r};${r + 12};${r}`} dur={`${4 + i}s`} repeatCount="indefinite" />
        </circle>
      ))}
      <circle cx="250" cy="200" r="0" fill="#4C30FF" opacity="0.1">
        <animate attributeName="r" from="20" to="170" dur="3s" repeatCount="indefinite" />
        <animate attributeName="opacity" from="0.18" to="0" dur="3s" repeatCount="indefinite" />
      </circle>

      {/* van */}
      <g transform="translate(250 200)" filter="url(#cv-shadow)">
        <rect x="-78" y="-34" width="118" height="62" rx="10" fill="#4C30FF" />
        <path d="M40 -22 H68 Q82 -22 86 -8 L90 10 Q90 28 76 28 H40 Z" fill="#3A1FE0" />
        <rect x="50" y="-16" width="26" height="20" rx="4" fill="#C9C4FF" />
        <rect x="-70" y="-26" width="100" height="42" rx="6" fill="#5B43FF" opacity="0.6" />
        <rect x="-78" y="22" width="168" height="8" rx="3" fill="#0E0E10" />
        <circle cx="-48" cy="34" r="12" fill="#0E0E10" />
        <circle cx="-48" cy="34" r="5" fill="#FFFFFF" />
        <circle cx="62" cy="34" r="12" fill="#0E0E10" />
        <circle cx="62" cy="34" r="5" fill="#FFFFFF" />
        {/* tracker unit blinking */}
        <rect x="-20" y="-50" width="40" height="14" rx="4" fill="#0E0E10" />
        <circle cx="-8" cy="-43" r="3" fill="#25D366">
          <animate attributeName="opacity" values="1;0.2;1" dur="1.2s" repeatCount="indefinite" />
        </circle>
        <text x="2" y="-40" fontFamily={FONT} fontSize="7" fontWeight="700" fill="#FFFFFF">
          GPS
        </text>
        {/* temperature sensor inside the cargo box */}
        <g transform="translate(-40 -2)">
          <rect x="-26" y="-13" width="52" height="26" rx="6" fill="#0E0E10" opacity="0.85" />
          <rect x="-19" y="-7" width="4" height="11" rx="2" fill="none" stroke="#C9C4FF" strokeWidth="1.3" />
          <circle cx="-17" cy="6" r="2.6" fill="#C9C4FF" />
          <line x1="-17" y1="-3" x2="-17" y2="5" stroke="#C9C4FF" strokeWidth="1.3" />
          <text x="-9" y="3.5" fontFamily={FONT} fontSize="9" fontWeight="700" fill="#FFFFFF">
            4.2°C
          </text>
          <circle cx="20" cy="-7" r="2.2" fill="#25D366">
            <animate attributeName="opacity" values="1;0.2;1" dur="1.6s" repeatCount="indefinite" />
          </circle>
        </g>
      </g>

      {/* callouts + data pulses */}
      {callouts.map((c, i) => {
        const cx = c.x + c.w / 2;
        const cy = c.y < 200 ? c.y + 46 : c.y;
        const path = `M${cx} ${cy} L${c.to[0]} ${c.to[1]}`;
        return (
          <g key={c.label}>
            <path d={path} stroke="#D6D6CE" strokeWidth="1.2" strokeDasharray="3 4" fill="none" />
            <circle r="3.5" fill={c.color}>
              <animateMotion dur={`${1.6 + i * 0.3}s`} repeatCount="indefinite" path={path} keyPoints="1;0" keyTimes="0;1" calcMode="linear" />
            </circle>
            <g transform={`translate(${c.x} ${c.y})`} filter="url(#cv-shadow)">
              <rect width={c.w} height="46" rx="10" fill="#FFFFFF" stroke="#E6E6E0" />
              <rect x="0" y="12" width="3" height="22" rx="1.5" fill={c.color} />
              <text x="12" y="18" fontFamily={FONT} fontSize="7.5" fontWeight="700" fill="#6B6B73" letterSpacing="1">
                {c.label}
              </text>
              <text x="12" y="34" fontFamily={FONT} fontSize="10.5" fontWeight="700" fill="#0E0E10">
                {c.value}
              </text>
            </g>
          </g>
        );
      })}

      {/* driver + behaviour chip */}
      <g transform="translate(167 352)" filter="url(#cv-shadow)">
        <rect width="146" height="30" rx="15" fill="#0E0E10" />
        <circle cx="15" cy="15" r="7" fill="#EDEAFF" />
        <text x="15" y="18" textAnchor="middle" fontFamily={FONT} fontSize="7.5" fontWeight="700" fill="#3A1FE0">
          O
        </text>
        <text x="28" y="18.5" fontFamily={FONT} fontSize="9" fontWeight="600" fill="#FFFFFF">
          Omar K. · safety score 94
        </text>
      </g>

      {/* uplink status */}
      <g transform="translate(171 14)" filter="url(#cv-shadow)">
        <rect width="138" height="22" rx="11" fill="#FFFFFF" stroke="#E6E6E0" />
        <circle cx="12" cy="11" r="3.5" fill="#25D366">
          <animate attributeName="opacity" values="1;0.3;1" dur="1.4s" repeatCount="indefinite" />
        </circle>
        <text x="22" y="14.5" fontFamily={FONT} fontSize="8.5" fontWeight="600" fill="#6B6B73" letterSpacing="0.8">
          LIVE · UPDATED 1s AGO
        </text>
      </g>
    </svg>
  );
};

/* Platform flow: any device -> Fleetroot platform -> outputs */
export const PlatformFlowVisual = ({ className = "" }) => {
  const inputs = ["GPS trackers", "OBD-II & CAN-bus", "Temp & door sensors", "Driver app", "Your existing devices"];
  const outputs = ["Live map & ETAs", "Alerts & automation", "Dispatch & routing", "Reports & KPIs", "API, webhooks, ERP"];
  const hubX = 240;
  return (
    <svg viewBox="0 0 480 400" xmlns="http://www.w3.org/2000/svg" className={className} role="img" aria-label="Any device feeds the Fleetroot platform, which powers maps, alerts, dispatch, reports and integrations" data-testid="platform-flow-visual">
      <defs>
        <filter id="pf-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#0E0E10" floodOpacity="0.10" />
        </filter>
      </defs>
      <rect width="480" height="400" fill="#FFFFFF" />
      <text x="16" y="30" fontFamily={FONT} fontSize="8.5" fontWeight="700" fill="#6B6B73" letterSpacing="1.2">
        ANY DEVICE
      </text>
      <text x="464" y="30" textAnchor="end" fontFamily={FONT} fontSize="8.5" fontWeight="700" fill="#6B6B73" letterSpacing="1.2">
        ONE PLATFORM, EVERY OUTPUT
      </text>

      {inputs.map((n, i) => {
        const y = 60 + i * 66;
        const path = `M150 ${y} C 172 ${y}, 172 200, ${hubX - 58} 200`;
        return (
          <g key={n}>
            <path d={path} fill="none" stroke="#E6E6E0" strokeWidth="1.5" />
            <circle r="3.5" fill="#4C30FF">
              <animateMotion dur={`${2 + i * 0.25}s`} begin={`${i * 0.3}s`} repeatCount="indefinite" path={path} />
            </circle>
            <g transform={`translate(16 ${y - 18})`} filter="url(#pf-shadow)">
              <rect width="134" height="36" rx="10" fill="#FFFFFF" stroke="#E6E6E0" />
              <circle cx="15" cy="18" r="4.5" fill="#EDEAFF" stroke="#4C30FF" strokeWidth="1.5" />
              <text x="26" y="21.5" fontFamily={FONT} fontSize="8.5" fontWeight="600" fill="#0E0E10">
                {n}
              </text>
            </g>
          </g>
        );
      })}

      {outputs.map((n, i) => {
        const y = 60 + i * 66;
        const path = `M${hubX + 58} 200 C 308 200, 308 ${y}, 330 ${y}`;
        return (
          <g key={n}>
            <path d={path} fill="none" stroke="#E6E6E0" strokeWidth="1.5" />
            <circle r="3.5" fill="#16A34A">
              <animateMotion dur={`${2 + i * 0.25}s`} begin={`${0.8 + i * 0.3}s`} repeatCount="indefinite" path={path} />
            </circle>
            <g transform={`translate(330 ${y - 18})`} filter="url(#pf-shadow)">
              <rect width="134" height="36" rx="10" fill="#FFFFFF" stroke="#E6E6E0" />
              <text x="10" y="22" fontFamily={FONT} fontSize="8.5" fontWeight="600" fill="#0E0E10">
                {n}
              </text>
              <circle cx="123" cy="18" r="2.5" fill="#16A34A">
                <animate attributeName="opacity" values="1;0.3;1" dur="1.4s" begin={`${i * 0.2}s`} repeatCount="indefinite" />
              </circle>
            </g>
          </g>
        );
      })}

      {/* hub */}
      <g transform={`translate(${hubX} 200)`} filter="url(#pf-shadow)">
        <circle r="66" fill="#4C30FF" opacity="0.08">
          <animate attributeName="r" values="62;72;62" dur="3s" repeatCount="indefinite" />
        </circle>
        <rect x="-58" y="-58" width="116" height="116" rx="28" fill="#0E0E10" />
        <text y="-20" textAnchor="middle" fontFamily={DISPLAY} fontSize="14" fontWeight="700" fill="#FFFFFF">
          fleetroot
        </text>
        {["Normalise", "Rules & AI", "Store & learn"].map((t, i) => (
          <g key={t} transform={`translate(0 ${-2 + i * 17})`}>
            <rect x="-42" y="-7" width="84" height="14" rx="7" fill="#FFFFFF" opacity={0.08 + i * 0.04} />
            <text y="3.5" textAnchor="middle" fontFamily={FONT} fontSize="8" fontWeight="600" fill="#C9C4FF">
              {t}
            </text>
          </g>
        ))}
      </g>
      <text x={hubX} y="392" textAnchor="middle" fontFamily={FONT} fontSize="8" fill="#9A9AA8">
        Protocol-agnostic ingestion · one data model · one login
      </text>
    </svg>
  );
};
